import React, {Component, Fragment} from 'react';
import { connect }                  from 'react-redux';
import { InView }                   from 'react-intersection-observer';
import {getFullMediaUrl} from 'app/static_func';

//assets
import './info_graphic.scss';
import car_check    from 'assets/icons/car_check.svg';
import car_wash     from 'assets/icons/car_wash.svg';
import car_history  from 'assets/icons/car_history.svg';
import car_warranty from 'assets/icons/car_warranty.svg';
import car_warranty_desktop from 'assets/icons/car_warranty_desktop.svg';

class InfoGraphic extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inView: {
                title:false,
                underline:false,
                subtitle:false,
                item1:false,
                item2:false,
                item3:false,
                item4:false,
            },
        }
        this.fadeUp = this.fadeUp.bind(this);
    }

    fadeUp(inView, entry, elm) {
        if(inView) {
            let newInviewState = {...this.state.inView, [elm]:true}
            this.setState({inView:newInviewState});
        } else {
            let newInviewState = {...this.state.inView, [elm]:false}
            this.setState({inView:newInviewState});
        }
    }

    render() {

        const text = this.props.text;

        const leasingCompanies = this.props.leasingCompanies;

        const notMobile = this.props.deviceState !== 'mobile';
        const item_class1 = this.props.deviceState === 'tablet' ? ' fade_left ' : ' fade_right ';
        const item_class2 = this.props.deviceState !== 'tablet' ? ' fade_left ' : ' fade_right ';

        return (
            <section className="info_graphic">
                <InView as="h2"
                        className= {"title fade_up" + (this.state.inView.title ? ' in' : '')}
                        onChange={(inView, entry) => this.fadeUp(inView, entry, 'title')}
                        threshold={1}>
                    {text['info_graphic_titles']}
                </InView>
                {notMobile &&
                    <Fragment>
                        <InView as="div"
                                className= {"underline fade_up" + (this.state.inView.underline ? ' in' : '')}
                                onChange={(inView, entry) => this.fadeUp(inView, entry, 'underline')}
                                threshold={1}>
                        </InView>
                        <InView as="h3"
                                className= {"subtitle fade_up" + (this.state.inView.subtitle ? ' in' : '')}
                                onChange={(inView, entry) => this.fadeUp(inView, entry, 'subtitle')}>
                            {text['info_graphic_subtitles']}
                        </InView>
                    </Fragment>
                }
                <div className="wrapper">
                    <InView as="div"
                            className= {"item fade_right" + (this.state.inView.item1 ? ' in' : '')}
                            onChange={(inView, entry) => this.fadeUp(inView, entry, 'item1')}
                            threshold={0.75}>
                            <div className="icon">
                                <img src= { leasingCompanies[0]!== undefined ? getFullMediaUrl(leasingCompanies[0].image.path) : car_wash } alt="car check" />
                            </div>
                            <div className="text">{leasingCompanies[0]!== undefined ? leasingCompanies[0].title : ''}</div>
                    </InView>

                    <InView as="div"
                            className= {"item" + item_class1 + (this.state.inView.item2 ? ' in' : '')}
                            onChange={(inView, entry) => this.fadeUp(inView, entry, 'item2')}
                            threshold={0.75}>
                            <div className="icon">
                                <img src= { leasingCompanies[1]!== undefined ? getFullMediaUrl(leasingCompanies[1].image.path) : car_check } alt="car check" />
                            </div>
                            <div className="text">{leasingCompanies[1]!== undefined ? leasingCompanies[1].title : 'כל רכב עובד בדיקה מקיפה'}</div>
                    </InView>

                    <InView as="div"
                            className= {"item" + item_class2 + (this.state.inView.item3 ? ' in' : '')}
                            onChange={(inView, entry) => this.fadeUp(inView, entry, 'item3')}
                            threshold={0.75}>
                        <div className="icon">
                            <img src= { leasingCompanies[2]!== undefined ? getFullMediaUrl(leasingCompanies[2].image.path) : car_history } alt="car check" />
                        </div>
                        <div className="text">{leasingCompanies[2]!== undefined ? leasingCompanies[2].title : 'גישה להיסטורית הטיפולים של הרכב'}</div>
                    </InView>

                    <InView as="div"
                            className= {"item fade_left" + (this.state.inView.item4 ? ' in' : '')}
                            onChange={(inView, entry) => this.fadeUp(inView, entry, 'item4')}
                            threshold={0.75}>
                        <div className="icon">
                            <img src= {leasingCompanies[3]!== undefined ? getFullMediaUrl(leasingCompanies[3].image.path) :(notMobile ? car_warranty_desktop : car_warranty)}  alt="car check" />
                        </div>
                        <div className="text last">{leasingCompanies[3]!== undefined ? leasingCompanies[3].title : 'אחריות מקיפה לשנה!'}</div>
                    </InView>
                </div>
            </section>
        );
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text:store.config.Translations,
        leasingCompanies: store.config.LeasingCompanies
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(InfoGraphic);
